import modules_form from './form/index.js'
import _actions_get from './_actions/get.js'
import _actions_clean_list from './_actions/clean_list.js'
import _actions_clean_form from './_actions/clean_form.js'
import _actions_clean from './_actions/clean.js'
import _mutations_tab from './_mutations/tab.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_items from './_mutations/items.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        items: _mutations_items,
        loading: _mutations_loading,
        tab: _mutations_tab,
    },
    actions:{
        clean: _actions_clean,
        clean_form: _actions_clean_form,
        clean_list: _actions_clean_list,
        get: _actions_get,
    },
    modules:{
        form: modules_form,
    },
}